import { createSelector } from 'reselect'
import config from 'constants/config'

const isPaymentScheduleEnabled = createSelector(
  (_state: App.State) => config.PAYMENT_SCHEDULE_ENABLED,
  (isEnabled) => {
    return !!isEnabled
  },
)

export default isPaymentScheduleEnabled
